import React from 'react';
import { BookOpenIcon, BrainIcon, LeafIcon, CheckCircle2Icon } from 'lucide-react';
const StatsWidget = () => {
  return <div className="bg-white rounded-xl border border-gray-200 overflow-hidden" data-id="element-1271">
      <div className="p-4" data-id="element-1272">
        <h2 className="text-base font-semibold text-gray-800 mb-4" data-id="element-1273">
          Statistiche Studio
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-1274">
          <StatCard icon={<LeafIcon className="text-gray-600" size={20} strokeWidth={1.5} data-id="element-1276" />} label="Azioni Sostenibili" value="142" trend="+12 questa settimana" trendUp={true} data-id="element-1275" />
          <StatCard icon={<BookOpenIcon className="text-gray-600" size={20} strokeWidth={1.5} data-id="element-1278" />} label="Lezioni Completate" value="28" trend="su 3 corsi attivi" data-id="element-1277" />
          <StatCard icon={<CheckCircle2Icon className="text-gray-600" size={20} strokeWidth={1.5} data-id="element-1280" />} label="Attività Completate" value="45" trend="Lezioni, quiz ed esercizi" trendUp={true} data-id="element-1279" />
          <StatCard icon={<BrainIcon className="text-gray-600" size={20} strokeWidth={1.5} data-id="element-1282" />} label="Streak di Studio" value="5" trend="giorni consecutivi" trendUp={true} data-id="element-1281" />
        </div>
      </div>
    </div>;
};
interface StatCardProps {
  icon: React.ReactNode;
  label: string;
  value: string;
  trend: string;
  trendUp?: boolean;
}
const StatCard: React.FC<StatCardProps> = ({
  icon,
  label,
  value,
  trend,
  trendUp
}) => {
  return <div className="p-3 border border-gray-200 rounded-lg" data-id="element-1283">
      <div className="flex items-center space-x-2 mb-2" data-id="element-1284">
        {icon}
        <div className="text-lg font-medium text-gray-800" data-id="element-1285">{value}</div>
      </div>
      <div className="text-sm text-gray-600 font-normal" data-id="element-1286">{label}</div>
      <div className={`text-xs ${trendUp ? 'text-green-600' : 'text-gray-500'} mt-1 font-normal`} data-id="element-1287">
        {trend}
      </div>
    </div>;
};
export default StatsWidget;